import { DateTime } from 'luxon';
import { ReactElement } from 'react';
import { BaseTableRows } from 'shell/components/shared/table/types';
import { Order } from 'shell/view-models/order';

export interface PecClient extends BaseTableRows {
  code: number;
  sent?: string;
  typeComunication?: string;
  object: string;
  message: ReactElement;
  dateHour: string;
  data?: string;
  state?: ReactElement;
  action?: ReactElement;
}

export interface FiltersFormPec {
  hasVisitedChild?: boolean;
  startDate?: DateTime | null;
  endDate?: DateTime | null;
  oggetto?: string;
  emailSender?: string;
  emailReceiver?: string;
  descriptionReceiver?: string;
  message?: string;
  typeComunication?: string;
  state?: string;
  codOperator?: string;
  page?: number;
  rowsPerPage?: number;
  orders?: Order;
}

export const initialValuesPec: FiltersFormPec = {
  state: '',
  startDate: null,
  endDate: null,
  emailSender: '',
  emailReceiver: '',
  descriptionReceiver: '',
  message: '',
  oggetto: '',
  typeComunication: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};
